import { sva } from '@agapi/ui/panda/css';

export const cardColumnsStyles = sva({
  slots: ['header', 'grid'],
  base: {
    header: {
      mb: '4',
      display: 'flex',
      flexDirection: 'column',
      gap: '2'
    },
    grid: {
      display: 'grid',
      gap: '5',
      width: 'full'
    }
  },
  variants: {
    columnCount: {
      '2': {
        grid: {
          gridTemplateColumns: {
            base: '1fr',
            md: 'repeat(2, 1fr)'
          }
        }
      },
      '3': {
        grid: {
          gridTemplateColumns: {
            base: '1fr',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)'
          }
        }
      },
      '4': {
        grid: {
          gridTemplateColumns: {
            base: '1fr',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(4, 1fr)'
          }
        }
      }
    },
    titleAlignment: {
      left: {
        header: {
          alignItems: 'flex-start',
          textAlign: 'left'
        }
      },
      center: {
        header: {
          alignItems: 'center',
          textAlign: 'center'
        }
      }
    }
  }
});